export default (ctx, html) => {
  if (ctx.loggedIn !== ctx['show-on-auth'] || !ctx.permitted) {
    return html``;
  }

  if (ctx['hide-user-type'] && ctx['hide-user-type'] === ctx.userType) {
    return html``;
  }

  return html`<slot></slot>`;
};
